export default __webpack_public_path__ + "static/uk-react-native-f355679bbf7d1fd6629f00fe74c3b6f5.webp";